import { Content } from '@carbon/react';
import { LoginPage } from './login';
import { Header } from './header';
import { useAtomValue } from 'jotai';
import { rootResourceAtom } from 'atoms/root';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { NewReleaseModal } from 'components/new-release-modal';
import { ReportFormHost } from 'components/report-form';
import { CoordinatePinsOverlay } from 'components/coordinate-pins';
import { useCurrentOncall } from 'pages/bugs-features/oncall-hooks';
import { searchLocations } from './hooks';

const AppShell = ({
  Router,
  csrfToken,
}: {
  Router: React.FunctionComponent;
  csrfToken: string;
}) => {
  const root = useAtomValue(rootResourceAtom);
  if (!root) return null;
  return (
    <HelmetProvider>
      <Helmet>
        <title>Insights</title>
      </Helmet>
      <Header title={'Insights'} />
      <Content id="main-content">
        {root && root.session ? (
          <>
            <NewReleaseModal />
            {/*
              Mounted here rather than per-page so the header's Report an issue
              button works everywhere. Renders nothing until opened.
            */}
            <ReportFormHost useOncall={useCurrentOncall} />
            {/* Dropped coordinate pins show on every map, not only the ones that
                offer the Coordinates tool. */}
            <CoordinatePinsOverlay searchLocations={searchLocations} />
            <Router />
          </>
        ) : (
          <LoginPage csrfToken={csrfToken} />
        )}
      </Content>
    </HelmetProvider>
  );
};

export { AppShell };
